module.exports = __webpack_public_path__ + "img/test3.1b0cdcdb.png";